"use client";

import { FC, useState, useEffect } from "react";
import { FaChevronDown } from "react-icons/fa";

export const ScrollDown: FC = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const fadeThreshold = 50; // Start fading after 50px of scroll

      if (scrollTop > fadeThreshold) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`absolute bottom-1 sm:bottom-4 left-1/2 transform -translate-x-1/2 z-10 transition-opacity duration-500 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
    >
      <div className="relative flex items-center justify-center">
        {/* Static chevron */}
        <FaChevronDown className="text-white/60 text-xl" />

        {/* Animated chevron - pushes down and returns */}
        <FaChevronDown
          className="absolute text-white/60 text-xl"
          style={{
            animation: "scrollDownPush 2s infinite 2s",
          }}
        />
      </div>

      <style jsx>{`
        @keyframes scrollDownPush {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(8px);
          }
        }
      `}</style>
    </div>
  );
};
